import React from 'react';
import Card from 'src/components/common/Card.redesign';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import Assignment from 'src/models/dlcLease/Assignment';

interface IAssignmentCardComponentProps {
    assignment: Assignment;

    onUpdateAssignment: (assignment: Assignment) => void;
}

const AssignmentCard = (props: IAssignmentCardComponentProps) => {
    
    const actions: ContextMenuAction[] = [{ text: 'Manage', action: () => props.onUpdateAssignment(props.assignment) }];
    
    return (
        <Card
            badge={`${props.assignment?.assign_no || 'N/A'}`}
            newContext={true}
            showMenu={true}
            contextActions={actions}
            collapse={true}
        >
            <div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', fontSize: '1.7rem' }}>
                    <div style={{width: '10%'}}>
                        <span 
                            className="data"
                        >
                            {props?.assignment?.assign_no || 'N/A'}
                        </span>
                    </div>
                    <div style={{width: '10%'}}>
                        {props?.assignment?.assign_type}
                    </div>
                    <div style={{width: '10%'}}>
                        {props?.assignment?.ack_type}
                    </div>
                    <div style={{width: '25%', textOverflow: 'ellipsis', overflow: 'hidden', display: 'inline-block', whiteSpace: 'nowrap'}}>
                        {props?.assignment?.assignor}
                    </div>
                    <div style={{width: '25%', textOverflow: 'ellipsis', overflow: 'hidden', display: 'inline-block', whiteSpace: 'nowrap'}} >
                        {props?.assignment?.assignee}
                    </div>
                    <div style={{width: '10%'}}>
                        {props?.assignment?.state}
                    </div>
                    <div style={{width: '10%'}}>
                        {props?.assignment?.county}
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default AssignmentCard;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/AssignmentCard.tsx